import { observer } from 'mobx-react-lite'
import { IconButton, type ITabItem, Typography } from 'shared/ui'
import { type BillingPeriod, TimePeriodTabs } from 'pages/settings/ui/BillingPlan'
import styles from './styles.module.scss'

type IPlanHeaderProps = {
  period: BillingPeriod
  handleSetPeriod: (tab: ITabItem<BillingPeriod>) => void
  previousStep: () => void
  isLastStep?: boolean
  title: string
}

export const PlanHeader = observer(
  ({ period, handleSetPeriod, previousStep, isLastStep, title }: IPlanHeaderProps) => {
    return (
      <>
        <div className={styles.headerNav}>
          <IconButton
            icon='arrowLeft'
            ariaLabel='previous-step'
            size='medium'
            variant='icon'
            color='tertiary'
            className={styles.previousStepButton}
            onClick={previousStep}
          />
        </div>
        <div className={styles.headerWrap}>
          <Typography ariaLabel='choose_plan_title' variant='heading-lg'>
            {title}
          </Typography>
          {!isLastStep && <TimePeriodTabs period={period} handleSetPeriod={handleSetPeriod} />}
        </div>
      </>
    )
  }
)
